var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.children
      ? _c(
          "ul",
          {
            staticClass: "sidebar-submenu absolute w-100 p0 bg-cl-primary",
            style: _vm.styles
          },
          [
            _vm.parentSlug
              ? _c(
                  "li",
                  {
                    staticClass:
                      "brdr-bottom-1 brdr-cl-bg-secondary bg-cl-primary flex"
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "px25 py20 cl-accent no-underline col-xs",
                        attrs: {
                          to: _vm.categoryLink({
                            url_path: _vm.parentPath,
                            slug: _vm.parentSlug
                          }),
                          "data-testid": "categoryLink"
                        }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.$t("View all")) + "\n      "
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.children, function(link) {
              return _c(
                "li",
                {
                  key: link.slug,
                  staticClass:
                    "brdr-bottom-1 brdr-cl-bg-secondary bg-cl-primary flex"
                },
                [
                  _vm.isCurrentMenuShowed
                    ? _c(
                        "div",
                        { staticClass: "subcategory-item" },
                        [
                          link.children_count > 0
                            ? _c("sub-btn", {
                                staticClass:
                                  "bg-cl-transparent brdr-none fs-medium",
                                attrs: { id: link.id, name: link.name }
                              })
                            : _c(
                                "router-link",
                                {
                                  staticClass:
                                    "px25 py20 cl-accent no-underline col-xs",
                                  attrs: { to: _vm.categoryLink(link) }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(link.name) +
                                      "\n        "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  link.children_count > 0
                    ? _c("sub-category", {
                        attrs: {
                          "category-links": link.children_data,
                          id: link.id,
                          "parent-slug": link.slug,
                          "parent-path": link.url_path
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.myAccountLinks && !_vm.hasChildren
      ? _c(
          "ul",
          {
            staticClass: "sidebar-submenu absolute w-100 p0 bg-cl-primary",
            style: _vm.styles
          },
          [
            _vm._l(_vm.myAccountLinks, function(link) {
              return _c(
                "li",
                {
                  key: link.id,
                  staticClass:
                    "brdr-bottom-1 brdr-cl-bg-secondary bg-cl-primary flex",
                  on: {
                    click: function($event) {
                      return _vm.notify(link.name)
                    }
                  }
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "px25 py20 cl-accent no-underline col-xs",
                      attrs: { to: _vm.localizedRoute(link.url) }
                    },
                    [_vm._v("\n        " + _vm._s(link.name) + "\n      ")]
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass:
                  "brdr-bottom-1 brdr-cl-bg-secondary bg-cl-primary flex"
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "px25 py20 cl-accent no-underline col-xs",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.logout($event)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(_vm.$t("Logout")) + "\n      ")]
                )
              ]
            )
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }